import React, { FC } from "react";
import { Alert } from "@security-watchdog/ui-components";

export const CheckAttentionAlert: FC = () => (
  <Alert variant="warning" className="margin-top-4">
    <p className="body-wide-line">One or more checks require your attention</p>
  </Alert>
);
